import Tile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
export function wmsLayer(ld: any, basemap: any, index: any, userId: any) {
  const workspace = ld.map.name.split(':');
  const server =
    ld.map.name.indexOf(':') === -1
      ? ld.map.server
      : ld.map.server.replace('wms', workspace[0] + '/wms');
  let style = '',
    iconUrl;
  const objLength = Object.keys(ld.style).length;
  if (ld.is_parcel_layer == true && objLength !== 0) {
    style = ld.style[basemap].workspace + ':' + ld.style[basemap].style;
  }
  if (ld.style.length > 0) {
    iconUrl = ld.style[basemap].icon;
    ld.legend['gs_icon_url'] = ld.legend.icon;
    ld.legend.icon =
      iconUrl.length > 1
        ? encodeURI(iconUrl)
        : encodeURI(ld.legend.icon.replace(/STYLE=.*/, 'STYLE=' + style));
  }
  const layer = new Tile({
    source: new TileWMS({
      url: server,
      params: {
        LAYERS: ld.map.name,
        TILED:
          ld.map.name.startsWith('wildfire_viewer') === true ? false : true,
        STYLES: style,
        FORMAT: 'image/png',
        viewparams: `user_id:${userId}`
      },
      projection: 'EPSG:3857',
    }),
    zIndex: index,
    visible: false,
    opacity: ld.opacity ? ld.opacity / 100 : 1,
  });
  layer.setProperties({ displayInLayerSwitcher: ld.legend.display });
  layer.setProperties({ isBaseLayer: ld.legend.base });
  layer.setProperties({ zoomlevel: ld.zoomlevel });
  layer.setProperties({ layer_object: ld });
  layer.setProperties({ isVisible: ld.map.visible });
  layer.setProperties({ isChecked: ld.map.visible });
  layer.setProperties({ id: ld.id });
  layer.setProperties({ type: ld.legend.heading });
  layer.setProperties({ allType: 'layers' });
  layer.setProperties({ selectable: ld.selectable });

  if (ld.legend.group) {
    layer.setProperties({ group: ld.legend.group });
  }

  if (ld.map.visible == true) {
    if (ld.legend.group == null) {
      if (ld.legend.class_group_checked) {
        layer.setProperties({ isVisible: true });
        layer.setProperties({ isChecked: true });
      }
    }
  }


  layer.setProperties({ classGroupType: ld.legend.class_group_type });
  // wi
  if (ld.legend.class_group) {
    layer.setProperties({ classGroup: ld.legend.class_group });
  }
  if (ld.legend.heading == null || ld.legend.heading == '') {
    layer.setProperties({ type: 'Overlays' });
  }
  if (ld.data_channel) {
    layer.setProperties({ channel: ld.data_channel });
  }
  return layer;
}
